import React from 'react';
import { Grid } from '@material-ui/core';
import { TextOverflow } from '../TextOverflow';
import { theme } from '../../theme';
export default function QuoteStatus(_a) {
    var children = _a.children;
    return (React.createElement(Grid, { container: true, justify: 'flex-end', alignItems: 'center', style: { marginRight: theme.spacing(1), width: 'initial' } },
        React.createElement(TextOverflow, { style: { fontSize: '0.65rem', width: 'initial' } }, children)));
}
